import { toast } from "react-toastify";
import { DropdownActions, DropdownItem } from "../../commons/DropdownActions";
import type { Report } from "@/services/webServices/report/types";
import { putReportStatus } from "../../../services/webServices/report/put";

type Props = {
  report: Report;
  onActionSuccessed: () => void;
};

export default function ReportAction({ report, onActionSuccessed }: Props) {

  const updateReportStatus = async (status: number): Promise<boolean> => {
    if (report.status === status) {
      toast.info("وضعیت همین الان هم همین است");
      return false;
    }

    try {
      const success = await putReportStatus({
        id: report.id,
        type: report.type,
        body: { status },
      });

      if (!success) return false;

      toast.success("تغییر وضعیت با موفقیت انجام شد");
      onActionSuccessed();
      return true;
    } catch {
      return false;
    }
  };

  const actions: DropdownItem[] = [
    {
      key: "checked",
      tone: "success",
      label: "بررسی شده",
      action: () => updateReportStatus(2),
    },
    {
      key: "notchecked",
      tone: "warning",
      label: "بررسی نشده",
      action: () => updateReportStatus(1),
    },
  ];

  return (
    <DropdownActions
      items={actions}
      initialKey={report.status === 1 ? "notchecked" : "checked"}
      disabled={false}
    />
  );
};